import { ReactNode, useState } from "react";
import classNames from "classnames";

import { IconChevronDown } from "@pentabd/icons";

interface AccordionDataType {
  accordionHeader: ReactNode;
  accordionBody: ReactNode;
  className?: string;
}

const Accordion = ({
  accordionBody,
  accordionHeader,
  className,
}: AccordionDataType) => {
  const [opened, setOpened] = useState(false);

  return (
    <div
      className={classNames("accordion-item pointer", className, {
        "accordion-item--opened": opened,
      })}
    >
      <div
        onClick={() => setOpened(!opened)}
        className="d-flex justify-content-between align-items-center py-6"
      >
        {accordionHeader}
        <div className="accordion-item__icon">
          <IconChevronDown size={20} />
        </div>
      </div>
      <div className="accordion-item__inner">
        <div className="accordion-item__content">{accordionBody}</div>
      </div>
    </div>
  );
};

export default Accordion;
